import Globalize from "globalize";
import ko from "knockout";

/*
 * ensure Object.create if not native (from Douglas Crockford)
 */
if (typeof Object.create !== "function") {
    Object.create = function (o) {
        function F() {}
        F.prototype = o;
        return new F();
    };
}

Object.defineProperty(Object.prototype, "typeof", {
    value: function(type){
        var o_type = Object.prototype.toString.call(this).slice(8, -1);
        if(!type || !(type.typeof() === "String"))
            return o_type;
        return o_type === type;
    },
    enumerable : false
});
Object.defineProperty(Object.prototype, "is_dom", {
    value: function(){
        return /HTML/.test(this.typeof());
    },
    enumerable : false
});

String.isString = function(s) {
    return Object.prototype.toString.call(s) === "[object String]";
};

Object.isObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
};

Object.defineProperty(Object.prototype, "iteritems", {
    value: function() {
        return Object.keys(this).map((key) => {
            return (key, this[key] || null);
        });
    },
    enumerable: false
});

Object.defineProperty(Object.prototype, "mapProperties", {
    value: function(func, keep_nulls) {
        let result = {};
        Object.keys(this).forEach((key) => {
            let [new_key, new_val] = func(key, this[key], this);
            if (new_val !== null || keep_nulls) {
                result[new_key] = new_val;
            }
        });
        return result;
    },
    enumerable: false
});



var _origParse = JSON.parse;
JSON.parse = function(text) {
    return _origParse(text, function(key, value) {
        var a;

        if (typeof value === "string") {
            a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(\+\d+:\d+){0,1}Z{0,1}$/.exec(value);
            if (a)
                return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));

            var dat = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
            if (dat) {
                return new Date(Date.UTC(+dat[1], +dat[2] - 1, +dat[3]));
            }

            if (value.slice(0, 5) === "Date(" && value.slice(-1) === ")") {

                var d = new Date(value.slice(5, -1));
                if (d)
                    return d;
            }
        }

        return value;
    });
};

String.prototype.format = function() {
    var args = arguments;
    if (args.length == 1 && (Array.isArray(args[0]) || Object.isObject(args[0]))) {
        args = args[0];
    }
    return this.replace(/{([\w\d._]+)(:([^:}]+))?(:([^}]+))?}/g, function(match, number, f, format, df, defaultval) {
        if (typeof args[number] != "undefined") {
            var val = ko.utils.unwrapObservable(args[number]);
            if (val === null || typeof val === "undefined" || val === "")
                return defaultval || "";
            if (typeof val.setMonth == "function") {
                if (format) {
                    if (format == "iso") {
                        return val.toISOString();
                    }
                    return Globalize.format(val, format);
                } else return Globalize.format(val, "d") + " " + Globalize.format(val, "t");
            }
            else if (format === "iso") {
                val = new Date(val);
                return val.toISOString();
            }
            else if (format) {
                return Globalize.format(val, format);
            }
            else return val;

        }
        else return match;
    }).replace(/http[s]?:\/\/{{crimson\.root}}/g, Crimson.root).replace(/{{crimson\.root}}/g, Crimson.root).replace(/{crimson\.root}/g, Crimson.root);
};

String.prototype.startsWith = function (str){
    return this.slice(0, str.length) == str;
};

//Extend Promise to have a done and fail function, and create a Deferred function.
Object.defineProperty(Promise.prototype, "done", {
    value: function(callback) {
        return this.then(callback);
    },
    enumerable: false
});

Object.defineProperty(Promise.prototype, "fail", {
    value: function(callback) {
        return this.then(null, callback);
    },
    enumerable: false
});

Object.defineProperty(Promise.prototype, "always", {
    value: function(callback) {
        return this.then(callback, callback);
    },
    enumerable: false
});

Object.defineProperty(Promise.prototype, "promise", {
    value: function() {
        return this;
    }, 
    enumerable: false
});
Promise.Deferred = function(this_or_none) {
    var resolver = null;
    var rejector = null;
    var state = "pending";
    var promise = this_or_none;
    if (promise) {
        Promise.call(promise, (resolve, reject) => {
            resolver = resolve;
            rejector = reject;
        });
    } else {
        promise = new Promise((resolve, reject) => {
            resolver = resolve;
            rejector = reject;
        });
    }

    promise.resolve = (res) => { state = "resolved"; resolver(res); return promise; }
    promise.reject = (res) => { state = "rejected"; rejector(res); return promise; }
    promise.state = function() { return state; };
    return promise;
}

//from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
/**
* Decimal adjustment of a number.
*
* @param {String}  type  The type of adjustment.
* @param {Number}  value The number.
* @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
* @returns {Number} The adjusted value.
*/
function decimalAdjust(type, value, exp) {
// If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? (+value[1] + exp) : exp));
}

// Decimal round
if (!Math.round10) {
    Math.round10 = function(value, exp) {
        return decimalAdjust("round", value, exp);
    };
}
// Decimal floor
if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
        return decimalAdjust("floor", value, exp);
    };
}
// Decimal ceil
if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
        return decimalAdjust("ceil", value, exp);
    };
}
// currency round
if (!Math.roundMoney) {
    Math.roundMoney = function(value) {
        return decimalAdjust("round", value, -2);
    };
}
